import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { announcementService } from '../services/announcementService';
import { Announcement } from '../types/announcement';
import { errorHandler } from '../utils/errorHandler';

const AnnouncementBanner: React.FC = () => {
    const [announcements, setAnnouncements] = useState<Announcement[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const loadAnnouncements = async () => {
            try {
                const activeAnnouncements = await announcementService.getActiveAnnouncements();
                setAnnouncements(activeAnnouncements);
            } catch (error) {
                errorHandler.handleError(error, 'Error loading announcements');
            }
        };

        loadAnnouncements();
        const interval = setInterval(loadAnnouncements, 5 * 60 * 1000); // Her 5 dakikada bir yenile

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (announcements.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % announcements.length);
            }, 5000); // Her 5 saniyede bir duyuru değiştir

            return () => clearInterval(interval);
        }
    }, [announcements.length]);

    if (!announcements.length) {
        return null;
    }

    const currentAnnouncement = announcements[currentIndex];

    return (
        <Snackbar
            open={true}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{ mt: 8 }}
        >
            <Alert 
                severity={currentAnnouncement.type}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {currentAnnouncement.content}
            </Alert>
        </Snackbar>
    );
};

export default AnnouncementBanner; 